// authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "YOUR_CLIENT_ID_FROM_AZURE",
    // 'common' allows users from any Azure account to attempt login
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

// Define your authorized domains here
// Read allowed domains from environment variable REACT_APP_ALLOWED_DOMAINS
// Expected format: comma-separated domains, e.g. "leglobal.ai,techvelocity.ai,imsabogado.com"
// For local development or if the env var is not set, fall back to the default list below.
const defaultAllowed = ["leglobal.ai", "techvelocity.ai", "imsabogado.com"];
export const ALLOWED_DOMAINS = (process.env.REACT_APP_ALLOWED_DOMAINS && typeof process.env.REACT_APP_ALLOWED_DOMAINS === 'string')
  ? process.env.REACT_APP_ALLOWED_DOMAINS.split(',').map(s => s.trim()).filter(Boolean)
  : defaultAllowed;
